import apiClient from '../apiClient';

class TrainingService {
  async getCourses() {
    return apiClient.get('/training/courses');
  }

  async getAllCourses() {
    return apiClient.get('/training/courses?active=false');
  }

  async getAllSessions() {
    return apiClient.get('/training/sessions?includeCancelled=true');
  }

  async getCourse(id) {
    return apiClient.get(`/training/courses/${encodeURIComponent(id)}`);
  }

  async getSessions(courseId) {
    const query = new URLSearchParams();
    if (courseId) query.set('courseId', courseId);
    query.set('status', 'published');
    const suffix = query.toString() ? `?${query.toString()}` : '';
    return apiClient.get(`/training/sessions${suffix}`);
  }

  async getPublicSessions(courseId) {
    const query = new URLSearchParams();
    if (courseId) query.set('courseId', courseId);
    query.set('status', 'published');
    const suffix = query.toString() ? `?${query.toString()}` : '';
    return apiClient.get(`/training/sessions${suffix}`);
  }

  async getSession(id) {
    return apiClient.get(`/training/sessions/${encodeURIComponent(id)}`);
  }

  async createEnrollment(payload) {
    return apiClient.post('/training/enrollments', payload);
  }

  async startCheckout(enrollmentId, options = {}) {
    return apiClient.post(`/training/enrollments/${encodeURIComponent(enrollmentId)}/checkout`, {
      accessToken: options.accessToken,
    });
  }

  async getEnrollment(id, options = {}) {
    const query = new URLSearchParams();
    if (options.accessToken) query.set('accessToken', options.accessToken);
    const suffix = query.toString() ? `?${query.toString()}` : '';
    return apiClient.get(`/training/enrollments/${encodeURIComponent(id)}${suffix}`);
  }

  async getAdminEnrollments() {
    return apiClient.get('/training/admin/enrollments');
  }

  async getAdminEnrollmentDetails(id) {
    return apiClient.get(`/training/admin/enrollments/${encodeURIComponent(id)}`);
  }

  async getAdminPayments() {
    return apiClient.get('/training/admin/payments');
  }

  async createCourse(payload) {
    return apiClient.post('/training/admin/courses', payload);
  }

  async updateCourse(id, payload) {
    return apiClient.patch(`/training/admin/courses/${encodeURIComponent(id)}`, payload);
  }

  async createSession(payload) {
    return apiClient.post('/training/admin/sessions', payload);
  }

  async updateSession(id, payload) {
    return apiClient.patch(`/training/admin/sessions/${encodeURIComponent(id)}`, payload);
  }

  // Partners
  async getPartners() {
    return apiClient.get('/training/admin/partners');
  }

  async createPartner(payload) {
    return apiClient.post('/training/admin/partners', payload);
  }

  async updatePartner(id, payload) {
    return apiClient.patch(`/training/admin/partners/${encodeURIComponent(id)}`, payload);
  }

  async deletePartner(id) {
    return apiClient.delete(`/training/admin/partners/${encodeURIComponent(id)}`);
  }

  // Course sort order
  async updateCourseSortOrder(orders) {
    return apiClient.put('/training/admin/courses/sort-order', { orders });
  }

  // Training stats (admin dashboard)
  async getTrainingStats() {
    return apiClient.get('/training/admin/stats');
  }
}

const trainingService = new TrainingService();
export default trainingService;
